import React from 'react';

import { Flex, Box, Divider } from '@chakra-ui/react';
import { Dropdown, DropdownContent, DropdownRadioGroup, DropdownRadioItem, DropdownTrigger } from '@mesh.ai/rabbit';
import { useHistory } from 'react-router-dom';
import { useReviewManageSidepanelData } from 'reducers/reviewManageSidepanelSlice';
import { useTalentPlanningSidepanelData } from 'reducers/talentPlanningSidepanelSlice';

import { ArrowDown16 } from 'assets/assetsV1/iconComponents';

import { routes } from 'constants/routes';

import { TextHeader2, TextLabel } from 'uiToolkitV1/Typography';

export const ReviewViewsSelection = ({ reviewCycleAndViewOptions, onReviewCycleChange, onCalibrationViewChange }) => {
  const { selectedReviewCycle } = useReviewManageSidepanelData();
  const { selectedCalibrationView } = useTalentPlanningSidepanelData();
  const history = useHistory();
  const isTalentPlanningPage = history.location.pathname.includes(routes.performanceReview.talentPlanning);
  const selectedValue = isTalentPlanningPage ? selectedCalibrationView : selectedReviewCycle;

  const { reviewCycles = [], calibrationViews = [] } = reviewCycleAndViewOptions;

  return (
    <Dropdown>
      <DropdownTrigger asChild>
        <Flex
          alignItems="center"
          sx={{
            borderBottom: '1px dashed #666666',
            '&[aria-expanded="true"]': {
              borderBottom: '1px solid #333333 !important',
            },
          }}
          _hover={{
            borderBottom: '1px solid #333333 !important',
          }}
          cursor="pointer"
        >
          <TextHeader2 bold>{selectedValue?.displayName || 'Select...'}</TextHeader2>
          <ArrowDown16 boxSize="16px" ml={1} />
        </Flex>
      </DropdownTrigger>

      <DropdownContent side="bottom" align="start">
        <Flex alignItems="center" w="100%" p="4px 8px">
          <TextLabel color="text.g2" bold>
            REVIEW CYCLE
          </TextLabel>
        </Flex>
        <DropdownRadioGroup
          style={{ maxHeight: '150px', overflowY: 'auto', overflowX: 'hidden' }}
          value={`reviewCycle${selectedValue?.uuid}`}
        >
          {reviewCycles.map((reviewCycle) => (
            <DropdownRadioItem
              value={`reviewCycle${reviewCycle.uuid}`}
              onClick={() => {
                onReviewCycleChange(reviewCycle);
              }}
              style={{
                marginBottom: '4px',
              }}
            >
              <span>{reviewCycle.displayName}</span>
            </DropdownRadioItem>
          ))}
        </DropdownRadioGroup>

        {calibrationViews.length > 0 && (
          <>
            <Divider opacity={1} bgColor="#EBEFF3" my="4px" />
            <Box w="100%" minW="168px">
              <Flex
                alignItems="center"
                w="100%"
                p="4px 8px"
                sx={{
                  '.chakra-button': {
                    paddingRight: 0,
                  },
                }}
              >
                <TextLabel color="text.g2" bold mb={1}>
                  CALIBRATION CYCLE
                </TextLabel>
                {/* <Button
                  StartIcon={ManageIcon}
                  ml="auto"
                  variant="tertiary"
                  sx={{
                    '.chakra-text': {
                      margin: 0,
                      marginLeft: '2px',
                    },
                  }}
                >
                  Manage
                </Button> */}
              </Flex>

              <DropdownRadioGroup value={`calibrationView${selectedValue?.uuid}`}>
                {calibrationViews.map((calibrationView) => (
                  <DropdownRadioItem
                    value={`calibrationView${calibrationView.uuid}`}
                    onClick={() => {
                      onCalibrationViewChange(calibrationView);
                    }}
                    style={{
                      marginBottom: '4px',
                    }}
                  >
                    <span>{calibrationView.displayName}</span>
                  </DropdownRadioItem>
                ))}
              </DropdownRadioGroup>
            </Box>
          </>
        )}
      </DropdownContent>
    </Dropdown>
  );
};
